/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { UPDATE_SELECTED_COUNTRIES,
    UPDATE_SELECTED_SITES,
    UPDATE_SELECTED_DEVICES,
    UPDATE_DATE_RANGE,
    UPDATE_REVENUE_TYPE,
    CLEAR_HOME_CONTROLS,
    GET_COUNTRIES
} from 'state/actions/homeState/home_analytics_status';
import { CLEAR_ALL_STATES } from 'state/actions/auth_status';
// utils
import { isAfterFourPM, getDateNYC, zeroPadding } from '@insticator/insticator-ui'; // iui-utils


/* ========== ~~~~~~~~~~ HOME ANALYTICS STATUS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components


//helpers

const generateDefaultStartDate = () => {
   let week = new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24 * 7) : (1000 * 60 * 60 * 24 * 8)));
   return `${week.getFullYear()}-${zeroPadding((week.getMonth() + 1), 2)}-${zeroPadding(week.getDate(), 2)}`;
};

const generateDefaultEndDate = () => {
    let today = new Date(getDateNYC() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2)));
    return `${today.getFullYear()}-${zeroPadding((today.getMonth() + 1), 2)}-${zeroPadding(today.getDate(), 2)}`;
};

const defaultStatus = {
    devices: ['MOBILE', 'DESKTOP'],
    selectedDevices: [],
    countries: {},
    countriesReceived: false,
    selectedCountries: [],
    sites: {},
    fetchingSites: false,
    selectedSites: [],
    embeds: [],
    selectedEmbeds: [],
    selectedRevenueType: '',
    dateRange: {
        from: generateDefaultStartDate(),
        to: generateDefaultEndDate()
    }
};



const homeAnalyticsStatus = (state = defaultStatus, action) => {
    let newState = JSON.parse(JSON.stringify(state));
    switch (action.type) {
        case UPDATE_SELECTED_COUNTRIES:
            newState.selectedCountries = action.countries;
            return newState;
        case UPDATE_SELECTED_SITES:
            newState.selectedSites = action.sites;
            return newState;
        case UPDATE_SELECTED_DEVICES:
            newState.selectedDevices = action.devices;
            return newState;
        case UPDATE_DATE_RANGE:
            newState.dateRange = action.range;
            return newState;
        case UPDATE_REVENUE_TYPE:
            newState.selectedRevenueType = action.revenueType;
            return newState;
        case GET_COUNTRIES:
            newState.countries = action.countries;
            newState.countriesReceived = true;
            return newState;
        case CLEAR_HOME_CONTROLS:
            newState.dateRange = defaultStatus.dateRange;
            newState.selectedSites = defaultStatus.selectedSites;
            newState.selectedCountries = defaultStatus.selectedCountries;
            newState.selectedDevices = defaultStatus.selectedDevices;
            return newState;
        case CLEAR_ALL_STATES:
            return defaultStatus;
        default:
            return newState;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default homeAnalyticsStatus;
